
import Vue from "vue";
import Crm from "@/models/crm/crm";
import AppCalendarSelect from "@/components/calendar/CalendarSelect.vue";
import { CalendarEvent } from "@/models/calendar-event";
import { CalendarService } from "@/services";
import { ISelectItem } from "winfakt-vue-components";
import { CrmSheduleCalendarOptions } from "@/utils/crm/crm-shedule-calendar-options";

export default Vue.extend({
	data(){
		return{
			date: new Date(),
			time: new Date(),
			addToCalendar: false,
			calendarId: 0,
			durationMinutes: 60,
			linkedEvent: null as null | CalendarEvent,
		};
	},
	props: {
		crm: {
			required: true,
			type: Object as () => Crm
		},
	},
	computed: {
		computeDate(): Date {
			return new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate(),
				this.time.getHours(), this.time.getMinutes(), 0);
		},
		durationItems(): ISelectItem<number>[] {
			return [15, 30, 45, 60, 90, 120, 180, 240].map(minutes => {
				let hours = Math.floor(minutes / 60);
				let rest = minutes % 60;
				let text = hours > 0 ? `${hours}u` : "";
				if (rest > 0) {
					text += `${rest}m`;
				}
				return {text, value: minutes};
			});
		},
		linkedCalendarName(): string {
			return this.linkedEvent?.Calendar?.Name || "";
		},
		saveDisabled(): boolean {
			return this.addToCalendar && !this.linkedEvent && this.calendarId == 0;
		}
	},
	methods: {
		cancel(){
			this.$emit("cancel");
		},
		remove(){
			this.crm.TimeSheduled = null;
			this.$emit("save");
			this.$emit("cancel");
		},
		save(){
			this.crm.TimeSheduled = this.computeDate;
			let options: CrmSheduleCalendarOptions | undefined;
			if (this.addToCalendar && !this.linkedEvent) {
				options = {calendarId: this.calendarId, durationMinutes: this.durationMinutes};
			}
			this.$emit("save", options);
			this.$emit("cancel");
		}
	},
	async created(){
		if (this.crm.TimeSheduled) {
			this.date = new Date(this.crm.TimeSheduled);
			this.time = new Date(this.crm.TimeSheduled);
		}
		if (!this.crm.ID) return;
		let events = await CalendarService.getEventsByCrm(this.crm.ID);
		this.linkedEvent = events.find(e => e.StartTimeIsLinkedToCrmTimeSheduled) || null;
	},
	components: {
		AppCalendarSelect
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
